<template>
  <v-navigation-drawer color="primary" width="200" app clipped fixed dark mobile-breakpoint="0" v-if="user && $route.name !== 'VerifyEmail'">
    <v-list dense>
      <!-- <v-list-item @click.stop="display = !display"> -->
      <!-- <v-icon>mdi-menu</v-icon> -->
      <!-- </v-list-item> -->
      <!-- <v-divider></v-divider> -->
      <v-list-item active-class="tile" v-for="item in this.filteredAuthTabs" :key="item.name" :to="item.route">
        <!-- <v-divider v-if="!item.id"></v-divider> -->
          <v-list-item-icon v-if="item.id">
            <v-icon color="white" style=" ">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content v-if="item.id">
            <v-list-item-title class="title-menu">{{ item.name }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-if="!item.id" class="px-5">
            <v-divider></v-divider>
          </v-list-item-content>
      </v-list-item>
    </v-list>
    <template v-slot:append>
      <div class="px-2">
        <v-list-item @click="logout" class="px-2" block>
          <v-list-item-icon class="ml-2">
            <v-icon color="white">mdi-logout</v-icon>
          </v-list-item-icon>
		  <v-list-item-content>
            <v-list-item-title class="title-menu">Ausloggen</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import logo from '../../assets/manushare.png'
import { mapState, mapActions, mapGetters } from 'vuex'

export default {
	name: 'AppMenu',
	data: () => ({
		logo,
		group: null,
		mini: true,
		display: true,
		currentCustomer: null,
		authTabs: [],
		purchaserTabs: [
			{ id: 1, name: 'Dashboard', route: '/dashboard', icon: 'mdi-speedometer', onlyAdmin: false },
			{ id: 3, name: 'Meine Anfragen', route: '/my-production-requests', icon: 'mdi-file-cog-outline', onlyAdmin: false },
			{},
			{ id: 5, name: 'Organisation', route: '/my-company', icon: 'mdi-domain', onlyAdmin: false },
			{ id: 6, name: 'Mein Profil', route: '/settings', icon: 'mdi-account-outline', onlyAdmin: false },
			{ id: 7, name: 'Admin', route: '/admin', icon: 'mdi-account-outline', onlyAdmin: true }
		],
		producerTabs: [
			{ id: 1, name: 'Dashboard', route: '/dashboard', icon: 'mdi-speedometer', onlyAdmin: false },
			{ id: 2, name: 'Marktplatz', route: '/marketplace', icon: 'mdi-animation-outline', onlyAdmin: false },
			{ id: 4, name: 'Meine Angebote', route: '/my-production-offers', icon: 'mdi-file-table-outline', onlyAdmin: false },
			{},
			{ id: 5, name: 'Organisation', route: '/my-company', icon: 'mdi-domain', onlyAdmin: false },
			{ id: 6, name: 'Mein Profil', route: '/settings', icon: 'mdi-account-outline', onlyAdmin: false },
			{ id: 7, name: 'Admin', route: '/admin', icon: 'mdi-account-outline', onlyAdmin: true }
		],
		bothTabs: [
			{ id: 1, name: 'Dashboard', route: '/dashboard', icon: 'mdi-speedometer', onlyAdmin: false },
			{ id: 2, name: 'Marktplatz', route: '/marketplace', icon: 'mdi-animation-outline', onlyAdmin: false },
			{ id: 3, name: 'Meine Anfragen', route: '/my-production-requests', icon: 'mdi-file-cog-outline', onlyAdmin: false },
			{ id: 4, name: 'Meine Angebote', route: '/my-production-offers', icon: 'mdi-file-table-outline', onlyAdmin: false },
			{},
			{ id: 5, name: 'Organisation', route: '/my-company', icon: 'mdi-domain', onlyAdmin: false },
			{ id: 6, name: 'Mein Profil', route: '/settings', icon: 'mdi-account-outline', onlyAdmin: false },
			{ id: 7, name: 'Admin', route: '/admin', icon: 'mdi-account-outline', onlyAdmin: true }
		]
	}),
	computed: {
		...mapState({
			user: (state) => state.auth.user
		}),
		customer () {
			return this.getCustomer().then((customer) => {
				this.currentCustomer = customer
			})
		},
		filteredAuthTabs() {
    		return this.authTabs.filter(item=>(!item.id || item.onlyAdmin === false || (item.onlyAdmin === true && this.user.role === 'admin')));
  		}
	},
	created () {
		this.customer.then(() => {
			this.setAuthTabs()
		})
	},
	methods: {
		...mapGetters('auth', ['isLogged']),
		...mapActions('auth', ['logout', 'getCustomer']),

		setAuthTabs () {
			switch (this.currentCustomer.type) {
			case 'producer':
				this.authTabs = this.producerTabs
				break
			case 'purchaser':
				this.authTabs = this.purchaserTabs
				break
			case 'both':
				this.authTabs = this.bothTabs
				break
			}
		}
	}
}
</script>

<style scoped>
.tile .v-list-item__icon {
  color: var(--v-secondary) !important;
}

.title-menu {
  font-family: 'Karla';
  font-style: normal;
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 20px !important;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em !important;
  color: #FFFFFF;
}

.tile {
  padding-left: 13px;
  border-left: 3px solid var(--v-secondary) !important
}

.tile2 {
  font-family: 'Karla';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  display: flex;
  align-items: center;
  letter-spacing: -0.02em;

  color: #FFFFFF;
}

.v-list-item {
  padding: 3%;
}

.tile[data-v-75e15521] {

  border-left: 2px solid #19D3DA !important;
  border-radius: 3%
}

.v-list .v-list-item--active .v-icon {
  color: inherit;
  margin-left: 60%;
}

.v-list .v-list-item .v-icon {
  color: inherit;
  margin-left: 60%;
}

</style>
